import {
  Box,
  VStack,
  DrawerHeader,
  HStack,
  IconButton,
  Text,
  Button,
} from '@chakra-ui/react';
import React from 'react';

import { Icon as FaIcon } from 'packages/common-frontend/components/icons';

export const DrawerSkeletonHeader = ({ onClose }: { onClose: () => void }) => {
  const headerText = 'Generate Report';
  return (
    <VStack alignItems="flex-start" ml="25px">
      <HStack justifyContent="space-between" alignItems="flex-end" w="100%">
        <Text fontWeight={600} lineHeight="28px" fontSize="20px">
          {headerText}
        </Text>
        <Box p="16px">
          <IconButton
            aria-label="Close"
            icon={<FaIcon icon="xmark-large" />}
            onClick={onClose}
            size="sm"
            variant="v2-ghost"
          />
        </Box>
      </HStack>
    </VStack>
  );
};
// header to use when we are showing back button.
const DrawerBackHeader = ({
  onBack,
  onClose,
}: {
  onBack: () => void;
  onClose: () => void;
}) => {
  const headerText = 'Generate Report';
  return (
    <VStack alignItems="flex-start" ml="25px">
      <HStack justifyContent="space-between" alignItems="center" w="100%">
        <Button
          leftIcon={<FaIcon icon="angle-left" />}
          variant="v2-ghost"
          colorScheme="v2-aurora"
          size="sm"
          onClick={onBack}
        >
          Back
        </Button>

        <Box p="16px">
          <IconButton
            aria-label="Close"
            icon={<FaIcon icon="xmark-large" />}
            onClick={onClose}
            size="sm"
            variant="v2-ghost"
          />
        </Box>
      </HStack>
      <Text fontWeight={600} lineHeight="28px" fontSize="20px">
        {headerText}
      </Text>
    </VStack>
  );
};

const DrawerMainHeader = ({
  onClose,
  onNewReport,
  onShowLatestPipelines,
}: {
  onClose: () => void;
  onNewReport?: () => void;
  onShowLatestPipelines?: () => void;
}) => {
  const headerText = 'Generate Report';
  return (
    <HStack justifyContent="space-between" alignItems="center" w="100%">
      <DrawerHeader flexGrow={1} maxWidth="90%">
        {headerText}
      </DrawerHeader>
      <HStack spacing="16px">
        {onShowLatestPipelines && (
          <Button
            variant="v2-ghost"
            colorScheme="v2-aurora"
            onClick={onShowLatestPipelines}
          >
            View Latest Reports
          </Button>
        )}
        {onNewReport && (
          <Button
            variant="v2-ghost"
            colorScheme="v2-aurora"
            onClick={onNewReport}
          >
            New Report
          </Button>
        )}
      </HStack>
      <Box p="16px">
        <IconButton
          aria-label="Close"
          icon={<FaIcon icon="xmark-large" />}
          onClick={onClose}
          size="sm"
          variant="v2-ghost"
        />
      </Box>
    </HStack>
  );
};

export const UploadDrawerHeader = ({
  showBackButton,
  onClose,
  onBack,
  onNewReport,
  onShowLatestPipelines,
}: {
  showBackButton: boolean;
  onClose: () => void;
  onBack: () => void;
  onNewReport?: () => void;
  onShowLatestPipelines?: () => void;
}) => {
  if (showBackButton) {
    return <DrawerBackHeader onBack={onBack} onClose={onClose} />;
  }
  return (
    <DrawerMainHeader
      onClose={onClose}
      onNewReport={onNewReport}
      onShowLatestPipelines={onShowLatestPipelines}
    />
  );
};
